export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Bold.1db18034.woff2";